import React from 'react';
import { Board } from '@/stores/canvasStore';
import { cn } from '@/lib/utils';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';

interface WallFilterBarProps {
  boards: Board[];
  selectedBoardIds: Set<string>;
  onToggleBoardFilter: (boardId: string) => void;
  isVisible?: boolean;
}

// Default tag colors for boards
const tagColorPalette = [
  '#EF4444', // red
  '#F97316', // orange
  '#22C55E', // green
  '#3B82F6', // blue
  '#8B5CF6', // purple
  '#EC4899', // pink
  '#14B8A6', // teal
  '#F59E0B', // amber
];

export function WallFilterBar({ boards, selectedBoardIds, onToggleBoardFilter, isVisible = true }: WallFilterBarProps) {
  if (!isVisible || boards.length === 0) return null;

  // Filter out the home board (parent_id === null)
  const filterableBoards = boards.filter(b => b.parent_id !== null);

  if (filterableBoards.length === 0) return null;

  return (
    <div className="max-w-6xl mx-auto px-6 pb-8">
      <ScrollArea className="w-full whitespace-nowrap">
        <div className="flex items-center gap-2 pb-2">
          {filterableBoards.map((board, index) => {
            const isSelected = selectedBoardIds.has(board.id);
            const dotColor = board.icon_color || tagColorPalette[index % tagColorPalette.length];
            
            return (
              <button
                key={board.id}
                onClick={() => onToggleBoardFilter(board.id)}
                className={cn(
                  'inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 shrink-0',
                  isSelected 
                    ? 'bg-white dark:bg-[#3a3a3a] shadow-md border border-gray-200 dark:border-gray-600 text-gray-900 dark:text-white' 
                    : 'bg-white dark:bg-[#2a2a2a] text-gray-600 dark:text-gray-400 hover:shadow-lg shadow-md border border-transparent'
                )}
              >
                <span 
                  className="w-2.5 h-2.5 rounded-full shrink-0"
                  style={{ backgroundColor: dotColor }}
                />
                {board.name}
              </button>
            );
          })}
          {/* REMOVED: Add Tag button */}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
}
